import ApiService from '@/services/core/api.service'

const PaymentRequestService = {
  async show (id) {
    return ApiService.get(`shared/payment-requests/${id}`)
  }
}

export default PaymentRequestService
